'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.itemHover = twentyninetimes.itemHover || function () {

	function init() {
		const hoverItems = document.querySelectorAll('.hover-animate-item');
		if ( hoverItems ) {
			itemHoverFunction(hoverItems);
		}
	}

	function itemHoverFunction(hoverItems) {
	    hoverItems.forEach(item => {
	        var bg  = item.querySelector('.hover-animate-item__bg'),
	            img = item.querySelector('.hover-animate-item__image');

	        item.addEventListener('mouseenter', function (e) {
	            const target = e.target;

	            //console.log(target);

	            item.classList.add('mouseover');
	        });

	        item.addEventListener('mousemove', function (e) {
	            // Get the target
	            const target = e.target.closest('.hover-animate-item');

	            var x = relativeCoords(e, target, 25).x,
	                y = relativeCoords(e, target, 25).y;

	            if (bg) bg.style.transform = `translate3d(${-x}px, ${-y}px, 0)`;
	            if (img) img.style.transform = `translate3d(${x}px, ${y}px, 0)`;
	        });

	        item.addEventListener('mouseleave', function (e) {
	            const target = e.target;

	            //console.log(target);

	            item.classList.remove('mouseover');
	            if (bg) bg.style.transform = `translate3d(0, 0, 0)`;
	            if (img) img.style.transform = `translate3d(0, 0, 0)`;
	        });
	    });
	}

	function relativeCoords( event, target, speed ) {
	    var speed  = speed ? speed : 10,
	        width  = target.clientWidth / 2,
	        height = target.clientHeight / 2,
	        bounds = target.getBoundingClientRect();

	    var x = ((event.clientX - bounds.left) - width) / speed;
	    var y = ((event.clientY - bounds.top) - height) / speed;
	    return {x: x, y: y};
	}

	return {
		init : init,
		itemHoverFunction : itemHoverFunction
	};

}();